import { apiClient } from "@/lib/api/client";
import { apiPaths } from "@/lib/api/paths";
import type { ExportReleasesResponse } from "./type";
import type { ReleasesFilters } from "../list/type";
import { isEmpty } from "@utils/formatters";

export async function exportReleases(
  query?: ReleasesFilters,
): Promise<ExportReleasesResponse> {
  const params = new URLSearchParams();

  if (query) {
    Object.entries(query).forEach(([key, value]) => {
      if (isEmpty(value)) return;

      params.append(key, String(value));
    });
  }

  let url = apiPaths.releases.export;
  if (params.toString()) {
    url += `?${params.toString()}`;
  }

  const response = await apiClient.get<ExportReleasesResponse>(url);

  return response.data;
}
